export function getSecurityTransferTypeByValue(type) {
  switch (type) {
    case 2:
      return 'receive_security'
    case 1:
      return 'send_security'
    default:
      return 'internal_security'
  }
}
